import React from 'react';
export function PrivacyPage() {
  return <div className="min-h-screen bg-white" data-id="element-373">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12" data-id="element-374">
        <h1 className="text-3xl font-bold text-gray-900 mb-10" data-id="element-375">
          Política de Privacidad y Protección de Datos
        </h1>

        <div className="space-y-6 text-gray-700 leading-relaxed" data-id="element-376">
          <p data-id="element-377">
            Las siguientes Políticas de Privacidad y Protección de Datos son
            aplicables a todas nuestras plataformas, incluyendo nuestro sitios
            web, APPs, terminales de auto-atención y puntos presenciales. Las
            mismas regulan el tratamiento y protección de los datos de carácter
            personal de los usuarios registrados con la finalidad de realizar
            Pagos de Servicios Públicos y Privados, Recargas de Prepagos y/o
            cualquier otra transacción a través de nuestra plataforma.
          </p>
          <p data-id="element-378">
            Al accesar, usted está aceptando, sin ninguna limitación, los
            términos y condiciones descritos a continuación:
          </p>

          <h3 className="text-xl font-bold text-gray-900 pt-2" data-id="element-379">
            Uso de los Datos Personales Registrados en Nuestras Plataformas
          </h3>
          <p data-id="element-380">
            Los datos referidos en estas políticas para el registro y para toda
            operación en línea, tendrán como finalidad validar las transacciones
            de pagos y mejorar la labor de información y comercialización de los
            productos y servicios prestados por ZUMPAGO.
          </p>
          <p data-id="element-381">ZUMPAGO utilizará la información para:</p>
          <ul className="list-disc pl-6 space-y-3" data-id="element-382">
            <li data-id="element-383">
              El propósito específico para el cual se la suministró: pagos por
              sus canales a través de tarjetas de crédito, débito, giftcard u
              otros medios.
            </li>
            <li data-id="element-384">
              Realizar solicitudes de reclamos para mejorar el servicio hacia
              nuestros clientes.
            </li>
            <li data-id="element-385">
              Contactar a cada usuario con fines comerciales para darle a
              conocer promociones o información importante sobre su cuenta, así
              como ofrecerte la venta de productos o servicios que podrían
              resultar de su interés.
            </li>
            <li data-id="element-386">
              Efectuar análisis conducentes a comprender a nuestros clientes
              para mejoras de nuestros servicios.
            </li>
            <li data-id="element-387">
              Aplicar estudios sobre los impactos de las campañas promocionales
              o publicitarias de ZUMPAGO.
            </li>
            <li data-id="element-388">
              Promover todos los protocolos o medidas de seguridad financiera,
              mitigar los riesgos o fraudes en los servicios que ofrecemos.
            </li>
            <li data-id="element-389">
              Utilizar la información personal para fines comerciales legítimos:
              Esto incluye el uso de información personal para analizar y
              mejorar nuestros productos, ubicaciones, servicios, operaciones,
              el funcionamiento de este sitio y la experiencia como cliente, y
              para medir el retorno de la inversión en marketing y la
              satisfacción de la marca. Esto puede incluir el uso de tu
              información para realizar estudios de mercado. También se podrá
              utilizar la información personal para proporcionar servicios a
              clientes y para ayudar a proteger la seguridad e integridad de
              nuestra tecnología, sistemas y servicios.
            </li>
            <li data-id="element-390">
              Utilizar la información personal con fines legales y de
              cumplimiento: esto incluye el uso de la información personal
              necesaria para cumplir con las obligaciones legales y regulatorias
              relacionadas con el antiblanqueo de dinero y contra la
              financiación del terrorismo; la detección, prevención y
              persecución del fraude y el robo, así como la prevención del uso
              ilegítimo o prohibido de nuestros servicios u otras actividades
              ilegales o ilícitas. Esto también puede incluir el
              establecimiento, el ejercicio o la defensa de los derechos y
              reivindicaciones legales de ZUMPAGO y otros, así como la
              vigilancia y el informe de asuntos de cumplimiento. Esto puede
              incluir además el uso de la información personal para validar y
              autenticar identidad, y la utilización de terceros para ayudarnos
              a hacerlo.
            </li>
          </ul>
          <p data-id="element-391">
            Cuando registra datos personales, estará automáticamente autorizando
            a ZUMPAGO a usar los datos personales de conformidad con esta
            Política de Privacidad y Protección de Datos.
          </p>
          <p data-id="element-392">
            Toda esta información será tratada como confidencial y su manejo se
            rige por la Política de Seguridad de ZUMPAGO, que puede ser
            observada en el sitio www.zumpago.com
          </p>

          <h3 className="text-xl font-bold text-gray-900 pt-2" data-id="element-393">
            Políticas de Creación de usuario
          </h3>
          <p data-id="element-394">
            El Usuario elegirá su propio identificador y contraseña. Para la
            elección del identificador, el Usuario no podrá optar por
            expresiones, palabras o conjuntos de letras que puedan resultar
            insultantes, injuriosos o contrarios a la ley, a la moral y a las
            buenas costumbres. De igual modo, tampoco podrá utilizar marcas,
            rótulos de establecimientos, expresiones publicitarias, nombres y
            pseudónimos de personajes públicos o conocidos sin su autorización.
            ZUMPAGO asignará el identificador seleccionado por el Usuario,
            siempre y cuando no haya sido previamente seleccionado por otro
            Usuario, en este caso no habrá reclamo alguno. El uso de la
            contraseña es personal e intransferible, no estando permitida la
            cesión, ni siquiera temporal, a terceros. En tal sentido, el Usuario
            se compromete a hacer un uso diligente y a mantener en secreto la
            misma, asumiendo toda responsabilidad por las consecuencias de su
            divulgación a terceros.
          </p>
          <p data-id="element-395">
            En el supuesto de que el Usuario conozca o sospeche del uso de su
            contraseña por terceros, deberá poner tal circunstancia en
            conocimiento de ZUMPAGO con la mayor brevedad posible, a fin de
            restringir el acceso de dicha contraseña.
          </p>

          <h3 className="text-xl font-bold text-gray-900 pt-2" data-id="element-396">
            Bloqueo de usuario
          </h3>
          <p data-id="element-397">
            Por seguridad del cliente, la cuenta de usuario puede bloquearse
            automáticamente luego de detectar diversos intentos fallidos al
            ingresar la contraseña.
          </p>
          <p data-id="element-398">
            Para desbloquear la cuenta de usuario por este motivo, el cliente
            deberá utilizar la opción de recuperar contraseña del sitio web o
            APP de ZUMPAGO. En caso de que esta opción no sea viable, podrá
            solicitar ello al e-mail del área de soporte:{' '}
            <a href="mailto:contacto@zumpago.com" className="text-zumpago-red hover:underline" data-id="element-399">
              contacto@zumpago.com
            </a>
            , quienes atenderán su solicitud y procederán con el desbloqueo del
            mismo luego de validar la identidad del que lo solicita.
          </p>

          <h3 className="text-xl font-bold text-gray-900 pt-2" data-id="element-400">
            Principios aplicados en el tratamiento de datos
          </h3>
          <p data-id="element-401">
            En el tratamiento de los datos personales, ZUMPAGO aplicará los
            siguientes principios que se ajustan a las exigencias de protección
            de datos:
          </p>
          <ul className="list-disc pl-6 space-y-3" data-id="element-402">
            <li data-id="element-403">
              <strong data-id="element-404">Principio de licitud, lealtad y transparencia:</strong>{' '}
              ZUMPAGO siempre requerirá el consentimiento para el tratamiento de
              los datos personales que puede ser para uno o varios fines
              específicos sobre los que se informará previamente con absoluta
              transparencia.
            </li>
            <li data-id="element-405">
              <strong data-id="element-406">Principio de minimización de datos:</strong> ZUMPAGO
              solicitará solo los datos estrictamente necesarios para el fin o
              los fines que los solicita.
            </li>
            <li data-id="element-407">
              <strong data-id="element-408">
                Principio de limitación del plazo de conservación:
              </strong>{' '}
              Los datos se mantendrán durante el tiempo estrictamente necesario
              para el fin o los fines del tratamiento. ZUMPAGO informará del
              plazo de conservación correspondiente según la finalidad.
            </li>
            <li data-id="element-409">
              <strong data-id="element-410">Principio de integridad y confidencialidad:</strong> Los
              datos serán tratados de tal manera que la seguridad,
              confidencialidad e integridad esté garantizada. ZUMPAGO realiza
              las mejores prácticas y precauciones necesarias para evitar el
              acceso no autorizado o uso indebido de los datos de sus usuarios
              por parte de terceros.
            </li>
          </ul>

          <h3 className="text-xl font-bold text-gray-900 pt-2" data-id="element-411">
            Seguridad de los datos personales
          </h3>
          <p data-id="element-412">
            Para proteger los datos personales, ZUMPAGO toma todas las
            precauciones razonables y sigue las mejores prácticas de la
            industria para evitar su pérdida, mal uso, acceso indebido,
            divulgación, alteración o destrucción de los mismos.
          </p>

          <h3 className="text-xl font-bold text-gray-900 pt-2" data-id="element-413">
            Exactitud y veracidad de los datos personales
          </h3>
          <p data-id="element-414">
            Cada usuario se compromete a que los datos facilitados a ZUMPAGO
            sean correctos, completos, exactos y vigentes, así como a
            mantenerlos debidamente actualizados.
          </p>
          <p data-id="element-415">
            Cada Usuario de las plataformas es el único responsable de la
            veracidad y corrección de los datos que remita al sitio, exonerando
            a ZUMPAGO de cualquier responsabilidad al respecto.
          </p>

          <h3 className="text-xl font-bold text-gray-900 pt-2" data-id="element-416">
            Propiedad intelectual
          </h3>
          <p data-id="element-417">
            Los derechos de propiedad intelectual contenidos en las plataformas
            de ZUMPAGO se encuentran protegidos por las leyes aplicables a la
            materia. En consecuencia, los elementos aquí incluidos (fotos,
            diseños, logos, entre otros), no pueden ser reproducidos, usados,
            adaptados o comercializados por este u otros medios sin la
            existencia de la aprobación previa y escrita de ZUMPAGO.
          </p>

          <h3 className="text-xl font-bold text-gray-900 pt-2" data-id="element-418">
            Aceptación y consentimiento
          </h3>
          <p data-id="element-419">
            Al utilizar las plataformas u otro canal de ZUMPAGO, usted declara
            haber sido informado de las condiciones sobre protección de datos de
            carácter personal, y acepta y consiente el tratamiento de los mismos
            por parte ZUMPAGO en la forma y para las finalidades indicadas en
            esta Política de Privacidad y Protección de Datos.
          </p>
          <p data-id="element-420">El tratamiento de tus datos se realiza con base en:</p>
          <ul className="list-disc pl-6 space-y-2" data-id="element-421">
            <li data-id="element-422">Tu consentimiento expreso.</li>
            <li data-id="element-423">
              El interés legítimo de ZUMPAGO para cumplir su misión
              institucional.
            </li>
            <li data-id="element-424">
              El cumplimiento de obligaciones legales, según la normativa
              ecuatoriana aplicable (Ley Orgánica de Protección de Datos
              Personales – LOPDP).
            </li>
          </ul>

          <h3 className="text-xl font-bold text-gray-900 pt-2" data-id="element-425">
            Derechos del titular de los datos
          </h3>
          <p data-id="element-426">Tienes derecho a:</p>
          <ul className="list-disc pl-6 space-y-2" data-id="element-427">
            <li data-id="element-428">Acceder a tus datos personales</li>
            <li data-id="element-429">Rectificar datos inexactos o incompletos</li>
            <li data-id="element-430">Eliminar tus datos (cuando proceda)</li>
            <li data-id="element-431">Oponerte al tratamiento</li>
            <li data-id="element-432">Solicitar la portabilidad de tus datos</li>
            <li data-id="element-433">Revocar el consentimiento en cualquier momento</li>
          </ul>
          <p data-id="element-434">
            Puedes ejercer estos derechos escribiéndonos a{' '}
            <a href="mailto:protecciondatos@zumpago.com" className="text-zumpago-red hover:underline" data-id="element-435">
              protecciondatos@zumpago.com
            </a>
          </p>

          <h3 className="text-xl font-bold text-gray-900 pt-2" data-id="element-436">
            Cambios en la Política de Privacidad
          </h3>
          <p data-id="element-437">
            ZUMPAGO se reserva el derecho a modificar la presente Política de
            Privacidad y Protección de Datos para adaptarla a novedades
            legislativas o jurisprudenciales, así como a prácticas de la
            industria.
          </p>
          <p className="text-sm text-gray-500 pt-4 border-t border-gray-100" data-id="element-438">
            La vigencia de estas Políticas de Privacidad y Protección de Datos
            es desde el 30 de marzo de 2025 y permanecerá vigente hasta que
            exista una nueva versión que la reemplace.
          </p>
        </div>
      </div>
    </div>;
}